<!--<app-header></app-header>-->
<div class="MainBg">
  <div class="MainInnerForm IFA_Mob_Margin">
    <div *ngIf="!IsMobile" class="SideMenu ValueAdds">
      <div class="SideMenuHeading">Transact</div>
      <div class="SideMenuLinks">
        <ul class="nav nav-tabs">
          <li class="SideMenuLinksInner">
            <a
              class="active show"
              routerLink="/transaction/new-nfo"
              routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Reports Icon/New_NFO_Report.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>NFO</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a routerLink="/transaction/lumpsum" routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Purchase.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Lumpsum Purchase</span>
            </a>
          </li>
          <li class="SideMenuLinksInner">
            <a routerLink="/transaction/sip" routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/SIP.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />

              <span>SIP</span>
            </a>
          </li>
          <li
            class="SideMenuLinksInner"
            [hidden]="!switchStatus"
            [ngClass]="switchStatus ? 'd-block' : 'd-none'">
            <a routerLink="/transaction/switch" routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Switch.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Switch</span>
            </a>
          </li>
          <li
            class="SideMenuLinksInner"
            [hidden]="!redeemStatus"
            [ngClass]="redeemStatus ? 'd-block' : 'd-none'">
            <a routerLink="/transaction/redeem" routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/Redeem.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>Redeem</span>
            </a>
          </li>
          <li
            class="SideMenuLinksInner"
            [hidden]="!SWPStatus"
            [ngClass]="SWPStatus ? 'd-block' : 'd-none'">
            <a routerLink="/transaction/swp" routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/SWP.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>SWP</span>
            </a>
          </li>

          <li
            class="SideMenuLinksInner"
            [hidden]="!STPStatus"
            [ngClass]="STPStatus ? 'd-block' : 'd-none'">
            <a routerLink="/transaction/stp" routerLinkActive="active">
              <img
                src="../../../assets/images/IFA/STP.svg"
                width="25"
                class="SideMenuIcon svg"
                type="image/svg+xml"
                pluginspage="http://www.adobe.com/svg/viewer/install/" />
              <span>STP</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="FormTemplate" [ngClass]="IsMobile ? 'p' : ''">
      <span *ngIf="!IsMobile" class="SectionHeading">New Fund Offer (NFO)</span>

      <div
        *ngIf="IsMobile"
        class="CommonSelectBoxTabsOuter CommonSelectBoxForm">
        <!-- <div class="SectionTopHeading HeadingReport NewHeaders fixed-top p-0">
          <span class="Mob_Heading_Top">Transact</span>
          <div class="Mob_Heading_Top"> 
            <a
            class=""
            routerLink="/transaction/new-nfo"
            routerLinkActive="active">
            NFO
          </a>
        </div>
        </div> -->
        <!-- d-none by pradnesh 04/09/2025 -->
        <div
          class="ResourcesTabs CustomTabs_IFA ScrollTabs PortfolioScrollTabs NewCustomTabs d-none">
          <!-- <ul class="nav nav-tabs p-0 Reports_Mob">
            <li>
              <a  routerLink='/value-add-service/branding' routerLinkActive='active'>Branding Images</a>
            </li>
            <li>
              <a routerLink='/value-add-service/scheme-returns' routerLinkActive='active'>Scheme Returns</a>
            </li>
            <li class="d-none">
              <a routerLink='/value-add-service/schemeperformancelumpsum' routerLinkActive='active'>Lumpsum Performance</a>
            </li>
            <li>
              <a routerLink='/transaction/new-nfo' routerLinkActive='active'>NFO</a>
            </li>
        </ul> -->

        <!-- d-none by pradnesh 04/09/2025 -->
          <ul class="nav nav-tabs p-0 Reports_Mob BorderBottom d-none">
            <li>
              <a
                class="active show"
                routerLink="/transaction/new-nfo"
                routerLinkActive="active">
                NFO
              </a>
            </li>
            <li>
              <a routerLink="/transaction/lumpsum" routerLinkActive="active">
                Lumpsum
              </a>
            </li>
            <li>
              <a routerLink="/transaction/sip" routerLinkActive="active">SIP</a>
            </li>
            <li
              [hidden]="!switchStatus"
              [ngClass]="switchStatus ? 'd-block' : 'd-none'">
              <a routerLink="/transaction/switch" routerLinkActive="active">
                Switch
              </a>
            </li>
            <li
              [hidden]="!redeemStatus"
              [ngClass]="redeemStatus ? 'd-block' : 'd-none'">
              <a routerLink="/transaction/redeem" routerLinkActive="active">
                Redeem
              </a>
            </li>
            <li
              [hidden]="!SWPStatus"
              [ngClass]="SWPStatus ? 'd-block' : 'd-none'">
              <a routerLink="/transaction/swp" routerLinkActive="active">SWP</a>
              <!-- <a>SWP</a> -->
            </li>
            <li
              [hidden]="!STPStatus"
              [ngClass]="STPStatus ? 'd-block' : 'd-none'">
              <a routerLink="/transaction/stp" routerLinkActive="active">STP</a>
              <!--  <a>STP</a> -->
            </li>
          </ul>
          
        </div>
      </div>
      <div
        class="TopFilters"
        [ngClass]="
          IsMobile
            ? 'ResourcesTabs CustomTabs_IFA ScrollTabs PortfolioScrollTabs NewCustomTabs hmp'
            : ''
        ">
        <div>
          <!-- <div class="SearchBox" *ngIf='!IsMobile'>
                  <input type="text" placeholder="Search Fund" #SeacrhFund class="ExploreSearch"
                      [(ngModel)]="SearchFund" (keyup)="MakeSearchFundArr($event.target.value)" />
                      <!-- <input type="text" placeholder="Search Fund" #SeacrhFund class="ExploreSearch"
                      /> -->
          <!--<img type="image/svg+xml" class="searchicon svg" src="../../assets/images/IFA/SearchBlue.svg" />
              </div> -->
          <br />
          <form form [formGroup]="FilterForm">
            <div *ngIf="!IsMobile" class="row">
              <div
                class="d-none col-md-2 col-md-2 col-sm-2 col-xs-12 InputBoxOuter">
                <div class="CheckAgree">
                  <label class="Cbx_container">
                    <input
                      class="customselect1"
                      type="radio"
                      formControlName="CheckFilter"
                      (click)="showFilterByAsset('ALL')"
                      name="CheckFilter"
                      value="0" />
                    <div class="checkmark"></div>
                    <label>All</label>
                  </label>
                </div>
              </div>
              <div
                class="col-md-2 col-md-2 col-sm-2 col-xs-12 InputBoxOuter">
                <div class="CheckAgree">
                  <label class="Cbx_container">
                    <input
                      class="customselect1"
                      type="radio"
                      formControlName="CheckFilter"
                      (click)="showFilterByAsset('G')"
                      name="CheckFilter"
                      value="1" />
                    <div class="checkmark"></div>
                    <label>Growth</label>
                  </label>
                </div>
              </div>

              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 InputBoxOuter">
                <div class="CheckAgree">
                  <label class="Cbx_container">
                    <input
                      class="customselect0"
                      type="radio"
                      formControlName="CheckFilter"
                      (click)="showFilterByAsset('DP')"
                      name="CheckFilter"
                      value="2" />
                    <div class="checkmark"></div>
                    <label>IDCW Payout</label>
                  </label>
                </div>
              </div>
              <div
                class="col-md-4 col-md-4 col-sm-4 col-xs-12 InputBoxOuter">
                <div class="CheckAgree">
                  <label class="Cbx_container">
                    <input
                      class="customselect2"
                      type="radio"
                      formControlName="CheckFilter"
                      (click)="showFilterByAsset('DR')"
                      name="CheckFilter"
                      value="3" />
                    <div class="checkmark"></div>
                    <label>IDCW Reinvestment</label>
                  </label>
                </div>
              </div>
            </div>

            <div *ngIf="IsMobile" class="FlexBox">
              <div class="d-none">
                <div class="CheckAgree">
                  <label class="Cbx_container">
                    <input
                      class="customselect1"
                      type="radio"
                      formControlName="CheckFilter"
                      (click)="showFilterByAsset('ALL')"
                      name="CheckFilter"
                      value="0" />
                    <div class="checkmark"></div>
                    <label>All</label>
                  </label>
                </div>
              </div>
              <div class="">
                <div class="CheckAgree">
                  <label class="Cbx_container">
                    <input
                      class="customselect1"
                      type="radio"
                      formControlName="CheckFilter"
                      (click)="showFilterByAsset('G')"
                      name="CheckFilter"
                      value="1" />
                    <div class="checkmark"></div>
                    <label>Growth</label>
                  </label>
                </div>
              </div>

              <div class="">
                <div class="CheckAgree">
                  <label class="Cbx_container">
                    <input
                      class="customselect0"
                      type="radio"
                      formControlName="CheckFilter"
                      (click)="showFilterByAsset('DP')"
                      name="CheckFilter"
                      value="2" />
                    <div class="checkmark"></div>
                    <label>Payout</label>
                  </label>
                </div>
              </div>
              <div class="">
                <div class="CheckAgree">
                  <label class="Cbx_container">
                    <input
                      class="customselect2"
                      type="radio"
                      formControlName="CheckFilter"
                      (click)="showFilterByAsset('DR')"
                      name="CheckFilter"
                      value="3" />
                    <div class="checkmark"></div>
                    <label>ReInvestment</label>
                  </label>
                </div>
              </div>
            </div>
          </form>
        </div>
        <!-- <span *ngIf='IsMobile' class="ReportFilterIcon ml-auto" (click)='ShowFilters()'>
              <i class="fa fa-filter" aria-hidden="true"></i></span> -->
        <!-- <div class="TopFiltersRdb">
              <div class="CheckAgree">
                  <label class="Cbx_container RadioBtn">
                      <input type="radio" name="TopFiltersRdbn" checked="true">
                      <span class="checkmark"></span><label>Added To Client Login</label>
                  </label>
              </div>
              <div class="CheckAgree ml-3">
                  <label class="Cbx_container RadioBtn">
                      <input type="radio" name="TopFiltersRdbn">
                      <span class="checkmark"></span><label>All Funds</label>
                  </label>
              </div>
          </div> -->
        <!--<div class="TopSroting">
              <div class="RightSideTabs">
                  <ul class="nav nav-tabs p-0">
                      <li>
                        <a data-toggle="tab" (click)="SortByAUM()" [class.active]="IsAUMActiveTab" class="active show">AUM</a>
                      </li>
                      <li>
                        <a data-toggle="tab" (click)="SortByLaunchDate()" [class.active]="IsLDActiveTab">Launch Date</a>
                      </li>
                      <li>
                        <a data-toggle="tab" (click)="SortBySchemeReturns()" [class.active]="IsSRActiveTab">Scheme Returns</a>
                      </li>
                  </ul>
              </div>
          </div>-->
      </div>

      <!-- <br /> -->
     <div [ngClass]=" !IsMobile ? 'NFOBoxScroll' : '' ">
      <div class="FundCardsOuter">
        <div *ngFor="let fund of ArrnfoData">
          <div class="SingleFundCard">
            <div class="FundInfo">
              <img
                src="../../assets/images/AMC_Logos/{{ fund.AmcCode }}.jpg"
                alt="AmcLogo" />
              <div class="FundCatInfo">
                <div class="FundName" [ngClass]="IsMobile ? 'NfoCardPaddBtm' : ''">
                  {{ fund.SchemeName }}
                </div>
                <span *ngIf="IsMobile" class="Mob_Risk">
                  {{ fund.CategoryName }}
                </span>
                <div *ngIf="!IsMobile" class="FundCat">
                  {{ fund.AssetType }}
                </div>
                <span
                  *ngIf="IsMobile && fund.RiskLable.length > 0"
                  class="Mob_Risk ml-2">
                  {{ fund.RiskLable }}
                </span>
                <div *ngIf="!IsMobile" class="FundCat d-none">
                  Scheme Launched on {{ fund.InceptionDate }}
                </div>
                <!-- <div *ngIf="IsMobile" class="SubText_Mob pt-2"><span> Inception Date :</span>&nbsp;
                            <span class="Recent-TopMost-text">{{fund.NFOStart | date:"dd/MM/yyy"}} to {{fund.NFOEnd | date:"dd/MM/yyy"}}</span>
                          </div> -->
                <div *ngIf="IsMobile" class="SubText_Mob NfoCardPaddTop">
                  <span>NFO Closes on</span>
                  &nbsp;
                  <span class="Recent-TopMost-text">
                    <!-- {{ fund.NFOStart | date: 'dd/MM/yyy' }} to -->
                    {{ fund.NFOEnd | date: 'dd/MM/yyy' }}
                  </span>
                </div>
                <!-- <span *ngIf="!IsMobile" class="FundCat">
                  Start Date {{ fund.NFOStart | date: 'dd/MM/yyy' }}
                </span> -->
                <br *ngIf="!IsMobile" />
                <span *ngIf="!IsMobile" class="FundCat">
                  NFO Closes on {{ fund.NFOEnd | date: 'dd/MM/yyy' }}
                </span>
              </div>
              <!-- <div class="CardKnowMoreText"
                          (click)="goToFactsheet(fund.SchemeCode,fund.BSESchemeCode,fund.BSEAMCCode,fund.AmcCode)">
                          Know More
                      </div> -->
            </div>
            <div *ngIf="!IsMobile" class="FundTheme_Risk">
              <div class="Theme_Risk ThemeSection">
                <span class="Theme_RiskQ">Investment Theme</span>
                <span class="Theme_RiskA">{{ fund.CategoryName }}</span>
              </div>
              <div class="Theme_Risk RiskSection">
                <span class="Theme_RiskQ">Risk</span>
                <span class="Theme_RiskA">{{ fund.RiskLable }}</span>
              </div>
            </div>
            <div class="FundAction" style="text-align: center">
              <div
                class="ActionBtn CursorPointer"
                (click)="
                  redirectToTransactPage(fund.BSESchemeCode, fund.BSEAMCCode, 0)
                ">
                Invest Lumpsum
              </div>
              <!-- <div class="ActionBtn CursorPointer">
                          Invest Lumpsum
                      </div> -->
              <div
                class="ActionBtn CursorPointer"
                (click)="
                  redirectToTransactPage(fund.BSESchemeCode, fund.BSEAMCCode, 1)
                ">
                Invest in sip
              </div>
              <!-- <div class="ActionBtn CursorPointer">
                          Invest in sip
                      </div> -->
            </div>
          </div>
        </div>
      </div>
     </div>
      <div class="row my-4">
        <div class="col text-center">
          <!-- <div *ngFor="let fund of ArrTempFundData | exploreFundsFilter
              : ''
              : ''
              : ''
              : ''
              : ''
              : ''
            : SearchFund
            : ''
            : ''
            : ''
            : ''
            : ''
            : ''
            let i = index;">
                  <a *ngIf='i == 0' class="loadMoreTextSize CursorPointer">
                      <span *ngIf='fund.IsShowLoadMore == true'>
                          Load More <i class="fa fa-angle-double-right ml-2" aria-hidden="true"></i></span>
                  </a>
              </div> -->
        </div>
      </div>
      <div
        class="NoResult"
        *ngIf="ArrnfoData.length == 0 && showNFODiv == true">
        <h1>Sorry!</h1>
        <h6>None of our schemes match your filter criteria</h6>
      </div>
    </div>
  </div>
</div>

<span *ngIf="!IsMobile">
  <app-footer></app-footer>
</span>
